export enum LabelPositionStyle {
  Left = 'Left',
  Top = 'Top',
}
